import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fj130_01: string;
  fj130_11: string;
  fj130_12: string;
  fj130_21: string;
  fj130_22: string;
  fj130_80: string;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const j5m3Api = {
  // POST /api/j5m3/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/j5m3/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/j5m3/execute
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j5m3/execute', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
